import type {ReactNode} from 'react';
import type {Moment} from 'moment';
import {Box, DatePicker, Stack, TextField} from '@wellstone-solutions/web';
import {isFutureDate} from '../dates';
import {markLabelRequiredSx} from '../NoteForm';

type EncounterSectionProps = {
  memberField: ReactNode;
  dateOfService: string;
  onDateOfServiceChange: (date: string) => void;
  staffName: string;
  organizationName: string;
};

export const EncounterSection = ({
  memberField,
  dateOfService,
  onDateOfServiceChange,
  staffName,
  organizationName,
}: EncounterSectionProps) => {
  const isFuture = isFutureDate(dateOfService);

  return (
    <Stack spacing={2}>
      <Stack direction={{xs: 'column', md: 'row'}} spacing={2}>
        <Box sx={{flex: 1}}>{memberField}</Box>
        <Box
          sx={{
            flex: 1,
            ...markLabelRequiredSx,
            '& .MuiTextField-root': {width: '100%'},
          }}>
          <DatePicker
            label="Date of service"
            fieldName="dateOfService"
            // Not in web's DatePicker types, but MUI merges it into the input
            {...{inputProps: {'aria-required': true}}}
            value={dateOfService}
            error={isFuture && "Date of service can't be in the future"}
            onChange={(date: Moment | null) =>
              onDateOfServiceChange(
                date?.isValid() ? date.format('YYYY-MM-DD') : '',
              )
            }
          />
        </Box>
      </Stack>
      <Stack direction={{xs: 'column', md: 'row'}} spacing={2}>
        <TextField label="Staff" value={staffName} disabled sx={{flex: 1}} />
        <TextField
          label="Organization"
          value={organizationName}
          disabled
          sx={{flex: 1}}
        />
      </Stack>
    </Stack>
  );
};
